import { render } from "./EditPlanForm.vue?vue&type=template&id=12dd87fb&scoped=true"
import script from "./EditPlanForm.vue?vue&type=script&lang=js"
export * from "./EditPlanForm.vue?vue&type=script&lang=js"

import "./EditPlanForm.vue?vue&type=style&index=0&id=12dd87fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd87fb"]])

export default __exports__